import { Core } from '@unseenco/taxi'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import App from '@scripts/app'
import TransitionManager from '@scripts/transitions/TransitionManager'
import TransitionHomeGallery from '@scripts/transitions/TransitionHomeGallery'
import Page from '@scripts/routes/Page'
import Home from '@scripts/routes/Home'
import About from '@scripts/routes/About'
import GallerySingle from '@scripts/routes/GallerySingle'

export default class RoutesManager {
  /**
   * Starts the Pages and Transitions.
   *
   * You can add your new Pages here.
   *
   */
  constructor() {
    /* Example of how to remove a page from the cache */
    // this.T.deleteCache(url)

    this.init = this.init.bind(this)
  }

  init() {
    return new Promise((resolve) => {
      this.T = new Core({
        removeOldContent: false,
        reloadJsFilter: false,
        renderers: {
          default: Page,
          home: Home,
          about: About,
          gallerySingle: GallerySingle
        },
        transitions: {
          default: TransitionManager,
          homeGallery: TransitionHomeGallery
        }
      })

      App.T = this.T

      const view = this.T.wrapper.querySelector('[data-taxi-view]')

      App.currentRenderer = view.$page

      resolve()
    })
  }

  events() {
    this.T.on('NAVIGATE_OUT', () => {
      App.isTransitioning = true

      App.scroll(false)
      App.locked(true)
      if (App.header.opened) App.header.toggle()
    })

    this.T.on('NAVIGATE_IN', ({ to }) => {
      App.currentRenderer = to.renderer
      App.header.refreshActivePage({
        to,
        location: window.location
      })
    })

    this.T.on('NAVIGATE_END', () => {
      App.cursor.events()
      ScrollTrigger.refresh()
      App.isTransitioning = false
      App.listenQuicklink()
      App.scroll(true)
      App.locked(false)
    })
  }
}
